export const AUTHENTICATION_FORGOT_PASSWORD_START = 'AUTHENTICATION_FORGOT_PASSWORD_START';
export const AUTHENTICATION_FORGOT_PASSWORD_ERROR = 'AUTHENTICATION_FORGOT_PASSWORD_ERROR';
export const AUTHENTICATION_FORGOT_PASSWORD_SUCCESSFUL = 'AUTHENTICATION_FORGOT_PASSWORD_SUCCESSFUL';
export const CLEAR_AUTHENTICATION_FORGOT_PASSWORD_STORE = 'CLEAR_AUTHENTICATION_FORGOT_PASSWORD_STORE';

export const AUTHENTICATION_RESET_PASSWORD_START = 'AUTHENTICATION_RESET_PASSWORD_START';
export const AUTHENTICATION_RESET_PASSWORD_ERROR = 'AUTHENTICATION_RESET_PASSWORD_ERROR';
export const AUTHENTICATION_RESET_PASSWORD_SUCCESSFUL = 'AUTHENTICATION_RESET_PASSWORD_SUCCESSFUL';
export const CLEAR_AUTHENTICATION_RESET_PASSWORD_STORE = 'CLEAR_AUTHENTICATION_RESET_PASSWORD_STORE';

export const AUTHENTICATION_VERIFY_EMAIL_START = 'AUTHENTICATION_VERIFY_EMAIL_START';
export const AUTHENTICATION_VERIFY_EMAIL_ERROR = 'AUTHENTICATION_VERIFY_EMAIL_ERROR';
export const AUTHENTICATION_VERIFY_EMAIL_SUCCESSFUL = 'AUTHENTICATION_VERIFY_EMAIL_SUCCESSFUL';
export const CLEAR_AUTHENTICATION_VERIFY_EMAIL_STORE = 'CLEAR_AUTHENTICATION_VERIFY_EMAIL_STORE';

export const AUTHENTICATION_ACTIVATE_ACCOUNT_START = 'AUTHENTICATION_ACTIVATE_ACCOUNT_START';
export const AUTHENTICATION_ACTIVATE_ACCOUNT_ERROR = 'AUTHENTICATION_ACTIVATE_ACCOUNT_ERROR';
export const AUTHENTICATION_ACTIVATE_ACCOUNT_SUCCESSFUL = 'AUTHENTICATION_ACTIVATE_ACCOUNT_SUCCESSFUL';
export const CLEAR_AUTHENTICATION_ACTIVATE_ACCOUNT_STORE = 'CLEAR_AUTHENTICATION_ACTIVATE_ACCOUNT_STORE';



// WEBPACK FOOTER //
// ./src/store/modules/authentication/mutation-types.js